import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42.667",
  height: "42.667",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M90 298C7 256-25 141 27 72 65 21 97 5 160 5s95 16 134 69c29 39 29 133 0 172-53 72-128 91-204 52m137-43c12-8 30-30 39-47 16-31 16-32-10-55-35-30-47-29-100 8-43 31-45 31-77 15-18-9-34-14-37-12-2 3 4 22 14 43 33 67 109 88 171 48",
      style: {"fill":"var(--fa-primary-color, currentColor)","opacity":"var(--fa-primary-opacity, 1)"},
      transform: "matrix(.1 0 0 -.1 0 32)"
    }, null, -1)
  ])))
}
export default { render: render }